module.exports = __webpack_public_path__ + "static/media/bestellijst.03009246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/bestellijst/bestellijst.jpg
// module id = 31
// module chunks = 0